import React from 'react';
import FormGroup from './FormGroup';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from '@mui/material';
import { Button, TextField, IconButton } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

const GenericFormGroup = ({ newItem, setNewItem, allergensList, selectedAllergens, handleAllergensChange, multiplePrices = false }) => {
  const handlePriceChange = (index, field, value) => {
    const updatedPrices = [...newItem.prices];
    updatedPrices[index][field] = value;
    setNewItem({ ...newItem, prices: updatedPrices });
  };

  const addPrice = () => {
    setNewItem({ ...newItem, prices: [...newItem.prices, { size: "", price: "" }] });
  };

  const removePrice = (index) => {
    const updatedPrices = newItem.prices.filter((_, i) => i !== index);
    setNewItem({ ...newItem, prices: updatedPrices });
  };

  return (
    <>
      <FormGroup label="Nome" value={newItem.name} onChange={(e) => setNewItem({ ...newItem, name: e.target.value })} />
      <FormGroup label="Descrizione" value={newItem.description} onChange={(e) => setNewItem({ ...newItem, description: e.target.value })} multiline rows={4} />
      
      {!multiplePrices ? 
        <FormGroup label="Prezzo" value={newItem.price} onChange={(e) => setNewItem({ ...newItem, price: e.target.value })} />
      :
        <>
        {newItem.prices?.map((priceObj, index) => (
            <div key={index} className="price-item">
              <TextField
                label="Quantità"
                value={priceObj.size}
                onChange={(e) => handlePriceChange(index, 'size', e.target.value)}
                margin="normal"
              />
              <TextField
                label="Prezzo"
                value={priceObj.price}
                onChange={(e) => handlePriceChange(index, 'price', e.target.value)}
                margin="normal"
              />
              <IconButton onClick={() => removePrice(index)}>
                <Delete />
              </IconButton>
            </div>
          ))}
          <Button onClick={addPrice} startIcon={<Add />} variant="contained">Aggiungi Prezzo</Button>
        </>
      }

      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel>Allergeni</InputLabel>
        <Select
          multiple
          value={selectedAllergens}
          onChange={handleAllergensChange}
          input={<OutlinedInput label="Allergeni" />}
          renderValue={(selected) => selected.join(', ')}
        >
          {allergensList.map((allergen) => (
            <MenuItem key={allergen} value={allergen}>
              <Checkbox checked={selectedAllergens?.indexOf(allergen) > -1} />
              <ListItemText primary={allergen} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
    );
}

export default GenericFormGroup;
